import { useNavigate } from 'react-router-dom';
import { Navbar } from '@/components/layout/Navbar';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Home, ArrowLeft } from 'lucide-react';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FFFFFF] flex flex-col">
      <Navbar />
      <div className="flex-1 flex items-center justify-center px-4">
        <Card className="border-0 shadow-[0_4px_20px_rgba(0,0,0,0.04)] rounded-[20px] bg-[#FFFFFF] max-w-md w-full">
          <CardContent className="p-12 text-center">
            <div className="relative mb-8">
              <div className="text-9xl font-bold text-[#F5F5F7]">404</div>
              <div className="absolute inset-0 flex items-center justify-center">
                <svg viewBox="0 0 100 100" className="w-24 h-24 opacity-40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="50" cy="38" r="26" fill="#E8E8ED" />
                  <ellipse cx="50" cy="65" rx="30" ry="25" fill="#E8E8ED" />
                  <ellipse cx="40" cy="36" rx="5" ry="6" fill="#C7C7CC" />
                  <ellipse cx="60" cy="36" rx="5" ry="6" fill="#C7C7CC" />
                </svg>
              </div>
            </div>
            <h1 className="text-2xl font-bold text-[#1D1D1F] mb-3">页面走丢了</h1>
            <p className="text-[#86868B] mb-8leading-relaxed">
              抱歉,您访问的页面不存在或已被移除
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Button
                onClick={() => navigate(-1)}
                variant="outline"
                className="rounded-full border-[#E8E8ED] hover:border-[#007AFF]/30 hover:bg-[#F5F5F7]"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                返回上一页
              </Button>
              <Button
                onClick={() => navigate('/')}
                className="rounded-full bg-[#007AFF] hover:bg-[#0066CC] text-white shadow-[0_4px_12px_rgba(0,122,255,0.15)]"
              >
                <Home className="w-4 h-4 mr-2" />
                回到首页
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default NotFound;
